<!-- Delete Confirm -->
<ng-template #confirm_delete_template
  let-dynamicDialogRef="dynamicDialogRef"
  let-dynamicDialogConfig="dynamicDialogConfig">
  <div class="flex flex-column gap-2">
    <span class="mb-2">
      {{ 'global.images_remove_confirm' | translate }}
    </span>
    <p-accordion [activeIndex]=""
      collapseIcon="false"
      expandIcon="false">
      @for (m of bulkEditAuthorFacade.snapshot_medias(); track mediaTrackBy($index, m)) {
        <p-accordionTab>
          <ng-template pTemplate="header">
            <div class="flex flex-row align-items-center justify-content-start gap-4 size-3">
              <medsurf-design-content-image [src]="mediaControlService.getUrl(m, 'thumbnail')"
                [width]="'50'"
                [height]="'50'"
                [inputClass]="'h-auto w-full'"
                [alt]="m.altText || 'global.error_loading_image' | translate">
              </medsurf-design-content-image>
              <span>{{ m.name }}</span>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            @if ({
              mediasUsedIn: mediaAuthorFacade.mediaUsedInById$(m.id) | async
            }; as mediaUsedInData) {
              @if (mediaUsedInData.mediasUsedIn === null) {
                <span>
                  {{ 'global.images_remove_no_used_in' | translate }}
                </span>
              }
              @if (mediaUsedInData.mediasUsedIn !== null) {
                <span>
                  {{ 'global.images_remove_used_in' | translate }}
                </span>
                <ul class="my-2">
                  @for (entry of (mediaUsedInData.mediasUsedIn); track trackByUsedIn($index, entry)) {
                    <li
                      class="p-1 opacity-50 text-500">
                      <medsurf-design-input-link [formField]="false"
                        [name]="'used_in'"
                        [label]="entry.title"
                      [href]="'/node/' + entry.id"></medsurf-design-input-link>
                    </li>
                  }
                </ul>
              }
            }
          </ng-template>
        </p-accordionTab>
      }
    </p-accordion>
    <p-footer>
      <div class="flex flex-row justify-content-end align-items-center column-gap-2">
        <button medsurf-design-input-button [id]="'cancel'"
          [label]="'global.cancel' | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
        (click)="dynamicDialogRef.close(false)"></button>
        <button medsurf-design-input-button [id]="'action'"
          [label]="dynamicDialogConfig.data.inputLabel | translate"
          [inputClass]="dynamicDialogConfig.data.inputClass"
        (click)="dynamicDialogRef.close(true)"></button>
      </div>
    </p-footer>
  </div>
</ng-template>

<!-- Search Results -->
<ng-template #search_results>
  <div [hidden]="isUploading()"
    class="w-full h-full overflow-hidden">
    <!-- Data View -->
    @let layout = (slideAuthorFacade.layout$ | async) ?? 'list';
    @if (searchControlFacade.mediaSearchResult$ | async; as mediaSearchResult) {
      <medsurf-design-content-sortable-data-view
        [value]="mediaSearchResult.items"
        [gridStyleClass]="'flex flex-wrap gap-2 ' + (!isModal() ? 'p-2' : 'pb-2')"
        [listStyleClass]="(!isModal() ? 'p-2' : 'pb-2')"
        [paginatorDropdownScrollHeight]="'300px'"
        [trackBy]="trackBy"
        [rows]="mediaSearchForm.value.rows || 10"
        [layout]="layout"
        (onChangeLayout)="changeLayout($event)"
        [pageLinks]="5"
        [totalRecords]="mediaSearchResult.total"
        [paginator]="true"
        [lazy]="true"
        [draggable]="false"
        [first]="mediaSearchForm.value.first || 0"
        (onLazyLoad)="onLazy($event)"
        (onPage)="onSubmit(false)">
        <!-- Header -->
        <ng-template pTemplate="header"
          class="overflow-auto h-full">
          <div [class]="'flex column-gap-2 w-full ' + (!isModal() ? 'p-2' : 'pt-2')">
            <div class="flex-grow-1">
              @if (mediaSearchForm) {
                <medsurf-design-form-control-form
                  [formGroup]="mediaSearchForm"
                  [class]="'w-full'"
                  (onSubmit)="onSubmit()">
                  <div class="flex flex-wrap gap-2">
                    <!-- Search String -->
                    <medsurf-design-form-control-input-text #searchStringInputText
                      [formField]="false"
                      [control]="mediaSearchForm.controls.searchString"
                      [autofocus]="true"
                      [class]="'flex-grow-1'"
                      [placeholder]="'global.search_query'"
                    (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
                    <!-- Type Filter -->
                    <medsurf-design-form-control-input-multi-select [formField]="false"
                      name="typeFilter"
                      [control]="mediaSearchForm.controls.typeFilter"
                      [options]="FlatModels.MediaEntityModels.MediaTypeArray(translate)"
                      [class]="'flex-grow-1'"
                      [placeholder]="'global.file_type'"
                    (valueChange)="onSubmit()"></medsurf-design-form-control-input-multi-select>
                    <!-- Is Unused -->
                    <medsurf-design-form-control-input-switch [formField]="false"
                      [control]="mediaSearchForm.controls.isUnused"
                      [class]="'flex'"
                      [label]="'global.unused'"
                      [labelTop]="false"
                    (valueChange)="onSubmit()"></medsurf-design-form-control-input-switch>
                    <!-- Uploaded By Me -->
                    <medsurf-design-form-control-input-switch [formField]="false"
                      [control]="mediaSearchForm.controls.uploadedByMe"
                      [class]="'flex'"
                      [label]="'global.uploaded_by_me'"
                      [labelTop]="false"
                    (valueChange)="onSubmit()"></medsurf-design-form-control-input-switch>
                    <!-- Is Duplicate -->
                    <medsurf-design-form-control-input-switch [formField]="false"
                      [control]="mediaSearchForm.controls.isDuplicate"
                      [class]="'flex'"
                      [label]="'global.is_duplicate'"
                      [labelTop]="false"
                    (valueChange)="onSubmit()"></medsurf-design-form-control-input-switch>
                    <!-- Used In Filter -->
                    <medsurf-design-form-control-input-node-tree-select [formField]="false"
                      [control]="mediaSearchForm.controls.usedInFilter"
                      [class]="'flex-grow-1'"
                      [placeholder]="'global.used_in'"
                    (valueChange)="onSubmit()"></medsurf-design-form-control-input-node-tree-select>
                  </div>
                </medsurf-design-form-control-form>
              }
            </div>
            <div class="flex flex-shrink-0 gap-2">
              <!-- Bulk Actions -->
              @if (!isModal()) {
                <medsurf-design-input-menu
                  [formField]="false"
                  [name]="'medias_menu'"
                  [label]="'global.medias'"
                [loadMenuItems]="getMediasMenuItems"></medsurf-design-input-menu>
              }
              <!-- Layout Options -->
              <medsurf-design-content-sortable-data-view-layout-options [layout]="layout"></medsurf-design-content-sortable-data-view-layout-options>
            </div>
          </div>
          <div class="p-2">
            @if (layout === 'list') {
              <div class="table-head h-5rem pl-2 pr-3 cursor-pointer overflow-hidden"
                >
                <div class="w-2rem">
                  &nbsp;
                </div>
                @if (!isModal()) {
                  <div
                    class="w-3rem flex-shrink-0">
                    &nbsp;
                  </div>
                }
                <div class="w-5rem flex-shrink-0">
                  &nbsp;
                </div>
                <span translate="global.file_type"
                class="w-8rem"></span>
                <span translate="global.title"
                class="w-20rem flex-grow-1"></span>
                <span translate="global.edited_at"
                class="w-13rem"></span>
                <span translate="global.size"
                class="w-5rem"></span>
                <span translate="global.access"
                class="w-5rem"></span>
              </div>
            }
          </div>
        </ng-template>
        <!-- Content -->
        <!-- List Item -->
        <ng-template pTemplate="listItem"
          let-media
          let-rowIndex="rowIndex">
          @if ({
            hasBulkEditMedia: (nodeSharedFacade.hasBulkEditMedia$(media.id) | async) || false,
            media: searchControlFacade.currentSelectedMedia$ | async
          }; as mediaData) {
            <div class="table-row h-5rem pl-2 cursor-pointer overflow-hidden hover:bg-primary-200 drag-node"
              [ngClass]="{'bg-primary-300': mediaData.hasBulkEditMedia && !isModal() || mediaData.media?.id === media.id}"
              (click)="onMediaClick($event, media)"
              (dblclick)="isModal() && mediaData.media && dynamicDialogRef.close(mediaData.media)">
              <div class="w-2rem">
                {{ rowIndex + mediaSearchForm.value.first + 1 }}
              </div>
              @if (!isModal()) {
                <div
                  class="w-3rem flex-shrink-0">
                  <medsurf-design-input-checkbox [formField]="false"
                    [name]="'media_list_select_' + media.id"
                    [model]="mediaData.hasBulkEditMedia"
                  (valueChange)="onToggleBulkMedia(media.id)"></medsurf-design-input-checkbox>
                </div>
              }
              <div class="w-5rem flex-shrink-0">
                @if (media.thumbnail) {
                  <img
                    class="block h-4rem w-4rem bg-black-alpha-30"
                    [src]="mediaControlService.getUrl(media, 'thumbnail')"
                    [alt]="media?.name || 'global.error_loading_image' | translate" />
                }
                @if (!media.thumbnail) {
                  <i
                    [class]="mediaControlService.getMediaTypeIcon(media)"
                  class="h-4rem w-4rem bg-black-alpha-30 align-items-center flex justify-content-center text-xl font-bold text-400"></i>
                }
              </div>
              <div class="w-8rem">
                <i [class]="mediaControlService.getMediaTypeIcon(media)"
                class="align-self-start p-2"></i>
                <span class="overflow-hidden text-overflow-ellipsis">
                  {{ 'enum.media.' + media.type | translate }}
                </span>
              </div>
              <span class="w-20rem flex-grow-1 text-overflow-ellipsis-2">
                {{ media.name }}
              </span>
              <span class="w-13rem">
                {{ media.editedAt | date_shared }}
              </span>
              <span class="w-5rem">
                {{ media.size * 1024 * 1024 | fileSize }}
              </span>
              <span class="w-5rem">
                @if (media.access === 'private') {
                  <p-tag 
                    [value]="'enum.media.private' | translate" 
                    severity="danger" />
                } @else {
                  <p-tag 
                    [value]="'enum.media.public' | translate" 
                    severity="success" />
                }
              </span>
            </div>
          }
        </ng-template>
        <!-- Grid Item -->
        <ng-template pTemplate="gridItem"
          let-media>
          @if ({
            hasBulkEditMedia: (nodeSharedFacade.hasBulkEditMedia$(media.id) | async) || false,
            media: searchControlFacade.currentSelectedMedia$ | async
          }; as mediaData) {
            <div class="flex flex-column w-12rem h-16rem border-1 border-round cursor-pointer overflow-hidden hover:border-primary-200 hover:bg-primary-200 drag-node"
              [ngClass]="{'bg-primary-300': mediaData.hasBulkEditMedia && !isModal() || mediaData.media?.id === media.id}"
              [title]="media.name"
              [class.opacity-10]="allowedTypes[0] && !allowedTypes.includes(media.type)"
              (click)="onMediaClick($event, media)"
              (dblclick)="isModal() && mediaData.media && dynamicDialogRef.close(mediaData.media)">
              <div class="relative flex w-12rem h-12rem">
                <medsurf-design-content-chip [tooltipLabel]="'global.file_type'"
                  [class]="'absolute top-0 left-0 m-2'">
                  <i [class]="mediaControlService.getMediaTypeIcon(media)"></i>
                </medsurf-design-content-chip>
                @if (!isModal()) {
                  <medsurf-design-input-checkbox
                    [formField]="false"
                    [class]="'h-3rem absolute top-0 right-0'"
                    [model]="mediaData.hasBulkEditMedia"
                    [name]="'media_grid_select_' + media.id"
                    (valueChange)="onToggleBulkMedia(media.id)"
                  ></medsurf-design-input-checkbox>
                }
                @if (media.access === 'private') {
                  <p-tag
                    [value]="'enum.media.private' | translate" 
                    class="absolute bottom-0 left-0 m-2"
                    severity="danger" />
                }
                @if (media.thumbnail) {
                  <img
                    class="w-full bg-black-alpha-30"
                    [src]="mediaControlService.getUrl(media, 'thumbnail')"
                    [alt]="media?.name || 'global.error_loading_image' | translate" />
                }
                @if (!media.thumbnail) {
                  <i
                    [class]="mediaControlService.getMediaTypeIcon(media)"
                  class="w-full bg-black-alpha-30 align-items-center flex justify-content-center text-3xl font-bold text-400"></i>
                }
              </div>
              <div class="flex w-12rem align-items-start h-4rem p-2">
                <span class="overflow-hidden text-overflow-ellipsis-2">
                  {{ media.name }}
                </span>
              </div>
            </div>
          }
        </ng-template>
      </medsurf-design-content-sortable-data-view>
    }
  </div>
</ng-template>

<!-- Splitter -->
<ng-template #search_splitter>
  @if ({
    currentSelectedMedia: searchControlFacade.currentSelectedMedia$ | async,
    mediaPanelData: slideAuthorFacade.mediaPanelData$ | async
  }; as mediaData) {
    <p-splitter
      [hidden]="isUploading()"
      class="flex flex-1 h-full overflow-hidden justify-content-center"
      styleClass="w-full"
      [panelStyleClass]="(mediaData.currentSelectedMedia !== null ? 'min-w-4_5rem' : '')"
      [gutterSize]="(mediaData.currentSelectedMedia !== null ? FlatModels.PanelDesignModels.panelGutterSizeBig : 0)"
      [panelSizes]="(mediaData.currentSelectedMedia !== null
        ? mediaData.mediaPanelData?.panelSize || FlatModels.PanelDesignModels.mediaPanelSize
        : [FlatModels.PanelDesignModels.panelMaxSize, FlatModels.PanelDesignModels.panelMinSize])"
      [minSizes]="(mediaData.currentSelectedMedia !== null
        ? [FlatModels.PanelDesignModels.panelMinSizeMain, FlatModels.PanelDesignModels.panelMinSizeBig]
        : [100, 0])"
      [layout]="'horizontal'"
      (onResizeStart)="mediaOnResizeStart()"
      (onResizeEnd)="mediaOnResizeEnd($event)">
      <ng-template pTemplate>
        <!-- Search Results -->
        <ng-container *ngTemplateOutlet="search_results"></ng-container>
      </ng-template>
      <!-- Sidebar -->
      <ng-template pTemplate>
        <medsurf-design-content-collapsible-panel [class]="'w-full'"
          [isMinimized]="mediaData.mediaPanelData?.isMinimized || false"
          [titleText]="'global.edit'"
          [id]="'media_menu'"
          [menuItems]="(editMenuItems$ | async) ?? []"
          (collapsedChange)="mediaCollapsedChange($event)">
          <medsurf-common-media-library-media-sidebar #media_sidebar
            [hidden]="mediaData.mediaPanelData?.isMinimized"
            class="flex flex-1 h-full"
          (mediaChange)="onSubmit()"></medsurf-common-media-library-media-sidebar>
        </medsurf-design-content-collapsible-panel>
      </ng-template>
    </p-splitter>
  }
</ng-template>

<!-- Media Library -->
<div class="flex flex-1 flex-column row-gap-2 h-full"
  [ngClass]="{'max-h-modal': isModal()}">
  <!-- Toolbar -->
  @if (!isModal()) {
    <medsurf-design-content-toolbar>
      <div class="p-toolbar-group-start">
        <div class="flex flex-row column-gap-2">
          <button medsurf-design-input-button [hidden]="isUploading()"
            [id]="'media_add'"
            [label]="'global.media_add' | translate"
            [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ADD"
          (click)="toggleIsUploading()"></button>
          <button medsurf-design-input-button [hidden]="!isUploading()"
            [id]="'back_to_overview'"
            [label]="'global.back_to_overview' | translate"
            [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.BACK"
          (click)="toggleIsUploading()"></button>
        </div>
      </div>
    </medsurf-design-content-toolbar>
  }

  <!-- Upload -->
  <medsurf-design-input-upload [hidden]="!isUploading()"
    [class]="'h-full'"
    [inputClass]="'h-full'"
    [name]="'media_upload'"
  (uploadFinished)="finishIsUploading($event)"></medsurf-design-input-upload>

  <!-- Search Results -->
  <div *ngTemplateOutlet="search_splitter"
    class="flex flex-1 overflow-hidden mb-2">
  </div>
</div>

<!-- Modal -->
@if (isModal()) {
  @if ({
    currentSelectedMedia: this.searchControlFacade.currentSelectedMedia$ | async
  }; as mediaData) {
    <div
      class="flex flex-row justify-content-between">
      <div class="flex flex-row column-gap-2">
        <button medsurf-design-input-button [hidden]="isUploading()"
          [id]="'media_add'"
          [label]="'global.media_add' | translate"
          [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ADD"
        (click)="toggleIsUploading()"></button>
        <button medsurf-design-input-button [hidden]="!isUploading()"
          [id]="'back_to_overview'"
          [label]="'global.back_to_overview' | translate"
          [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.BACK"
        (click)="toggleIsUploading()"></button>
      </div>
      <!-- Close Modal Button -->
      <button medsurf-design-input-button [id]="'media_choose'"
        [label]="'global.choose' | translate"
        [disabled]="!mediaData.currentSelectedMedia"
        [hidden]="isUploading()"
      (click)="mediaData.currentSelectedMedia && dynamicDialogRef.close(mediaData.currentSelectedMedia)"></button>
    </div>
  }
}

